import React, { PropTypes } from 'react';
import { IconButton, FontIcon } from 'material-ui';
import PDFPreview from './pdfPreview';
// import PowerPointPreview from './pptPreview';
import VideoPreview from './videoPreview';
import R from 'ramda';

const Lightbox = props => {
  const {
    viewingFileIndex,
    changePage,
    filesLength,
    closeLightbox,
    viewingFile,
  } = props;

  return (
    <div>
      <div
        id="file-preview-modal-overlay"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 50,
          background: 'rgba(0, 0, 0, 0.6)',
          display: 'none',
        }}
      />
      <div
        id="file-preview-modal"
        style={{
          display: 'none',
          width: '100%',
          maxWidth: '100%',
          maxHeight: '100%',
          height: '100%',
          position: 'fixed',
          zIndex: 100,
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          boxShadow: '0 0 60px 10px rgba(0, 0, 0, 0.9)',
        }}
      >
        <div style={{ position: 'absolute', zIndex: 1, top: '2%', right: '2%', backgroundColor: 'transparent' }}>
          <IconButton onTouchTap={closeLightbox}>
            <FontIcon className="tc-icon-close" color="#FFFFFF" style={{ fontSize: '16px' }} />
          </IconButton>
        </div>
        <div style={{
          display: 'flex',
          transform: 'translate(-50%, -50%)',
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '100%',
          alignItems: 'center', alignContent: 'center', justifyContent: 'space-between',
          height: '100%',
          overflow: 'hidden' }}
        >
          <IconButton
            onTouchTap={() => changePage(viewingFileIndex - 1)}
            disableTouchRipple
            disabled={viewingFileIndex === 0}
            iconStyle={{ fontSize: '75px', cursor: 'pointer' }}
            style={{ padding: 0, margin: 0 }}
          >
            <FontIcon className="tc-icon-navigate_before" color="#FFFFFF" />
          </IconButton>
          <div style={{ maxWidth: '75%', maxHeight: '650px', marginLeft: '25px' }}>
            {
              R.call(R.cond([
                [R.either(R.equals('image/png'), R.equals('image/jpeg')), R.always(
                  <img src={R.propOr('', 'url', viewingFile)} style={{ maxWidth: '100%', maxHeight: '550px' }} />)],
                [R.equals('application/pdf'), R.always(
                  <PDFPreview fileName={R.propOr('', 'name', viewingFile)} url={R.propOr('', 'url', viewingFile)} fullSize />)],
                [R.either(R.equals('video/mp4'), R.equals('video/quicktime')), R.always(
                  <VideoPreview fileName={R.propOr('', 'name', viewingFile)} url={R.propOr('', 'url', viewingFile)} fullSize />)],
                // [R.either(R.equals('application/vnd.ms-powerpoint'), R.equals('application/vnd.openxmlformats-officedocument.presentationml.presentation')), R.always(
                  // <PowerPointPreview fileName={R.propOr('', 'name', viewingFile)} url={R.propOr('', 'url', viewingFile)} fullSize />)],
                [R.T, R.always(<span/>)],
              ]), R.propOr('', 'mediaType', viewingFile))
            }
          </div>
          <IconButton
            onTouchTap={() => changePage(viewingFileIndex + 1)}
            disableTouchRipple
            disabled={viewingFileIndex === filesLength - 1}
            iconStyle={{ fontSize: '75px', cursor: 'pointer' }}
            style={{ marginRight: '25px', padding: 0, margin: 0 }}
          >
            <FontIcon className="tc-icon-navigate_next" color="#FFFFFF" />
          </IconButton>
        </div>
      </div>
    </div>
  );
};

Lightbox.propTypes = {
  changePage: PropTypes.func,
  filesLength: PropTypes.number,
  viewingFile: PropTypes.object,
  viewingFileIndex: PropTypes.number,
  closeLightbox: PropTypes.func,
};

export default Lightbox;



// WEBPACK FOOTER //
// ./src/app/components/extra/filePreview/lightbox.jsx